import styled from 'styled-components';

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const LeftSide = styled.div`
  align-items: baseline;
  display: flex;
`;
